import { render } from "./UseCaseModal.vue?vue&type=template&id=20d76bde&scoped=true"
import script from "./UseCaseModal.vue?vue&type=script&lang=js"
export * from "./UseCaseModal.vue?vue&type=script&lang=js"

import "./UseCaseModal.vue?vue&type=style&index=0&id=20d76bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d76bde"]])

export default __exports__